module.exports = __webpack_public_path__ + "static/media/7.52bf1e6a.jpg";